class Controller {
  constructor($mdDialog, $injector, customer) {
    "ngInject";

    this.$injector = $injector;
    this.$mdDialog = $mdDialog;
    this.customer = customer;
    this.geteway = "email";
  }

  close() {
    this.$mdDialog.cancel();
  }

  confirm() {
    this.$mdDialog.hide({ geteway: this.geteway });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/customer/resetPasswordDialog/resetPasswordDialog.controller.js